import type { Column } from '@tanstack/react-table'
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface Props<TData, TValue> {
  column: Column<TData, TValue>
  title: string
  className?: string
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className
}: Props<TData, TValue>) {
  if (!column.getCanSort()) {
    return <span className={className}>{title}</span>
  }

  const sorted = column.getIsSorted()

  return (
    <Button
      variant='ghost'
      size='sm'
      onClick={() => column.toggleSorting(sorted === 'asc')}
      className={`-ml-3 h-8 cursor-pointer data-[state=open]:bg-accent sm:h-8 ${className ?? ''}`}
    >
      <span>{title}</span>
      {sorted === 'desc' ? (
        <ArrowDown className='ml-1 size-3.5' />
      ) : sorted === 'asc' ? (
        <ArrowUp className='ml-1 size-3.5' />
      ) : (
        <ChevronsUpDown className='ml-1 size-3.5 opacity-50' />
      )}
    </Button>
  )
}
